<ng-diversions-review-details
  *ngIf="(store$ | async) as store"
  [configs]="configs"
  [data]="store.data"
  [loading]="store.loading"
  (refresh)="dispatchLoadData()">
</ng-diversions-review-details>
